import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-reset-password-response-modal',
  templateUrl: './reset-password-response-modal.component.html'
})
export class ResetPasswordResponseModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { success: boolean },
  ) { }
}
